import { createQueryKeys } from "@lukemorales/query-key-factory";
import { getSchedule } from "../api/RequesTixApi";

export const schedule = createQueryKeys("schedule", {
  getSchedule: (startDate: string, endDate: string, homeTeamId: string | number, opponentTeamId: string | number) => ({
    queryKey: [startDate, endDate, homeTeamId, opponentTeamId],
    queryFn: () => getSchedule(homeTeamId, opponentTeamId, startDate, endDate),
  }),
});
